// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1rRc6","notes":"Notes_notes__nVgeD"};